export enum HealthStatus {
  Healthy = 1,
  Unhealthy = 2,
  Unknown = 3,
}

export interface HealthCheck {
  id: string;
  applicationDefinitionId: string;
  applicationDefinitionName: string;
  agentId: string;
  agentVersion: string;
  checkTime: string;
  healthStatus: HealthStatus;
  healthStatusName: string;
  details?: string;
}

export interface CurrentHealthStatus {
  applicationDefinitionId: string;
  applicationDefinitionName: string;
  latestHealthStatus: HealthStatus;
  latestHealthStatusName: string;
  latestCheckTime: string;
  latestDetails?: string;
  last24HoursHealthyCount: number;
  last24HoursUnhealthyCount: number;
  last24HoursUnknownCount: number;
  totalChecksLast24Hours: number;
}

export interface HealthCheckHistoryResult {
  items: HealthCheck[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}











